/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import Configuration from './base/configuration';
import ConfigureComparision from './base/configure-comparison';
import ConfigureLimit from './base/configure-limit';
import ConfigureSort from './base/configure-sort';

const BarChartConfiguration = (props) => {
	return (
		<Configuration title='Configure table'>
			<ConfigureLimit />
			<ConfigureSort />
			<ConfigureComparision />
		</Configuration>
	);
};

export default BarChartConfiguration;
